const React = require('react');
const classnames = require('classnames');
import ShopDeliveryInfo from './shop-deliverty-info';
import HttpsProtocolImage from '../../component/common/https-protocol-image';
const helper = require('../../helper/dish-helper');
const commonHelper = require('../../helper/common-helper');
const defaultShopLogo = require('../../asset/images/shop-logo-default.svg');
const searchLogo = require('../../asset/images/search-black.svg');
import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import shopMessages from '../../intl/messages/shop';
import globalMessages from '../../intl/messages/global';

require('./ads-column.scss');

const type = helper.getUrlParam('type');
const basicListInfo = localStorage.basicListInfo;
const way = JSON.parse(basicListInfo || '{}').way; // 自提外送

const AdsColumn = React.createClass({
  displayName: 'AdsColumn',
  propTypes: {
    dishesData: React.PropTypes.array,
    shopInfo: React.PropTypes.object,
    shopLogo: React.PropTypes.string,
    marketList: React.PropTypes.object,
    marketListUpdate: React.PropTypes.array,
    multiMarketing: React.PropTypes.array,
    notice: React.PropTypes.string,
    openShopTime: React.PropTypes.any,
    openShopTimeStr: React.PropTypes.string,
    setAllDiscount: React.PropTypes.func.isRequired,
    takeawayServiceProps: React.PropTypes.object,
    discountProps: React.PropTypes.object,
    searchTouch: React.PropTypes.func,
    flodUpAppendCss: React.PropTypes.string,
    isShowHalf: React.PropTypes.bool, // 是否显示第二杯半价的信息
  },
  getInitialState() {
    return { animation: {}, allDiscount: false, totalShowScroll: [] };
  },
  componentWillMount() {
    const { marketListUpdate, multiMarketing, notice, openShopTimeStr } = this.props;
    const totalShowScroll = [{ type: -2, openShopTimeStr }]
      .concat(marketListUpdate || [])
      .concat(multiMarketing || [])
      .concat(notice && notice.replace(/(\r|\n)/g, '').trim().length > 0 ? [{ type: -1, notice }] : []);

    this.setState({ totalShowScroll });
  },
  componentDidMount() {
    this._setInterval = setInterval(() => {
      const { totalShowScroll } = this.state;
      if (totalShowScroll.length === 1) {
        return;
      }
      const distanceClass = { top: '-26px', transition: 'all .5s' };
      this.setState({ animation: distanceClass }, () => {
        setTimeout(() => {
          this.setState({ animation: { top: 0, transition: 'none' }, totalShowScroll: this.changeMarketList(totalShowScroll) });
        }, 500);
      });
    }, 5000);
  },
  componentWillUnmount() {
    clearInterval(this._setInterval);
  },
  changeMarketList(list = []) {
    const copyList = Array.prototype.slice.call(list);
    [].push.call(copyList, copyList.shift());
    return copyList;
  },
  showAllDiscount() {
    const { shopInfo, shopLogo, notice, openShopTime, takeawayServiceProps, discountProps } = this.props;
    const scrollPart = this.scrollPartFunc();
    const chargeDiscountPart = this.chargeDiscountPartFunc();
    let sendText = '';
    const phoneNumber = `${commonHelper.validateForeignAreaCode(shopInfo.nationTelCode) || ''} ${shopInfo.mobile}`;
    const phone = `${commonHelper.validateForeignAreaCode(shopInfo.nationTelCode) || ''}${shopInfo.serviceMobile}`;

    if (type === 'WM' && way !== 'zt') {
      sendText = <ShopDeliveryInfo takeawayServiceProps={takeawayServiceProps} />;
    }

    const discountElement = (
      <div className="ads-detail">
        <HttpsProtocolImage className="ads-icon" src={shopLogo || defaultShopLogo} alt={formatMessage(globalMessages.shopIcon)} />
        <p className="shopname o-text-ellipsis">{shopInfo.commercialName || <FormattedMessage {...shopMessages.unknownShop} />}</p>
        <p className="shopinfo">{sendText}</p>
        <div className="fieldset-outer">
          <fieldset className="shopdiscount">
            <legend className="shopdiscount-brief">
              <FormattedMessage {...shopMessages.info} />
            </legend>
            <div className="scrollpart">
              <div className="o-flex">
                <FormattedMessage {...shopMessages.openhour} />：{openShopTime || <FormattedMessage {...globalMessages.allDay} />}
              </div>
              {shopInfo.mobile && (
                <div className="o-flex">
                  <FormattedMessage {...shopMessages.tel} />：
                  <div className="o-flex__fluid">
                    <a href={`tel:${phoneNumber}`} className="clickphonecolor">
                      {phoneNumber}
                    </a>
                    {shopInfo.serviceMobile && (
                      <a href={`tel:${phone}`} className="clickphonecolor">
                        {phone}
                      </a>
                    )}
                  </div>
                </div>
              )}
              {shopInfo.address && (
                <div className="o-flex">
                  <FormattedMessage {...shopMessages.address} />：<div className="o-flex__fluid">{shopInfo.address}</div>
                </div>
              )}
              {discountProps.validTime && (
                <div className="o-flex">
                  <FormattedMessage {...shopMessages.vipPriceAvaliableTime} />：
                  <div className="o-flex__fluid">{`${discountProps.levelName} ${discountProps.validTime}`}</div>
                </div>
              )}
            </div>
          </fieldset>
          {((scrollPart && scrollPart.length !== 0) || (chargeDiscountPart && chargeDiscountPart.length !== 0)) && (
            <fieldset className="shopdiscount">
              <legend className="shopdiscount-brief">
                <FormattedMessage {...shopMessages.privilegeInfo} />
              </legend>
              <div className="scrollpart">
                {scrollPart}
                {chargeDiscountPart} {/* 部分商品每满1份限免x份加料  */}
              </div>
            </fieldset>
          )}
          {notice && notice.replace(/(\r|\n)/g, '').trim().length > 0 && (
            <fieldset className="shopdiscount">
              <legend className="shopdiscount-brief">
                <FormattedMessage {...shopMessages.announcement} />
              </legend>
              <div className="scrollpart noticepart">{notice}</div>
            </fieldset>
          )}
        </div>
        <div className="closedetail" onTouchTap={this.hideAllDiscount}></div>
      </div>
    );

    const { setAllDiscount } = this.props;
    setAllDiscount(discountElement);
  },
  hideAllDiscount(e) {
    e.stopPropagation();
    e.preventDefault();
    const { setAllDiscount } = this.props;
    setAllDiscount(null);
  },
  construntRuleName(item) {
    const {
      consumeLimit,
      ruleName,
      dishNum,
      isHalfPrice = false, // 是否第二份半价活动 - 是则只显示满x份享x
      stackRule = false, // 第二份半价活动是否开启叠加
    } = item;
    const currency = sessionStorage.getItem('currency');
    const { isShowHalf } = this.props; // 只有快餐、外卖显示

    if (isHalfPrice && isShowHalf) {
      // 第二份半价活动只显示 满x份享x活动
      // globalMessages.fullDishNumRuleEvery
      // return (
      //   <span>
      //     {stackRule && <FormattedMessage {...globalMessages.fullDishNumRuleEvery} values={{ symbol: '' }} />}
      //     <FormattedMessage {...globalMessages.fullDishNumRule} values={{ symbol: '', dishNum, ruleName: ` ${ruleName}` }} />
      //   </span>
      // );
      return <span>{ruleName}</span>;
    }

    // 满{currency}{consumeLimit}{ruleName}
    if (!item.dishId) {
      return <FormattedMessage {...globalMessages.fullMoneyRule} values={{ symbol: ' ', dishNum: consumeLimit, ruleName }} />;
    }
    if (item.dishNum > 1) {
      // 满{dishNum}份{ruleName}
      return <FormattedMessage {...globalMessages.fullDishNumRule} values={{ symbol: ' ', dishNum, ruleName }} />;
    }
    return item.ruleName;
  },
  construntDishNum(item, condition) {
    const dishNum = item.dishNum;

    if (!item.dishId) {
      return '';
    }
    const str = !item.shared ? '，不与满减、单品折扣、代金券等优惠同享' : '';
    if (condition) {
      return formatMessage(globalMessages.perOrderLimitNum, { dishNum, symbol: ',', str });
    }
    return formatMessage(globalMessages.perOrderLimitNum, { dishNum, symbol: '', str });
  },
  scrollPartFunc() {
    const { marketListUpdate, shopInfo, multiMarketing } = this.props;
    const formatDishesData = shopInfo.formatDishesData;
    const infoList = marketListUpdate ? marketListUpdate.concat(multiMarketing || []) : multiMarketing || [];
    // console.log('---infoList--', infoList);
    const scrollAll = infoList.map((item, index) => {
      if (item.dishId && !formatDishesData[item.dishId]) {
        return false;
      }
      if (item.isHalfPrice && !this.props.isShowHalf) {
        return null;
      } // 第二杯半价只有快餐 外卖显示
      let vip = '';
      if (item.customerType && item.customerType === 1) {
        vip = formatMessage(globalMessages.limitedVIP, { symbol: ',' });
      } else if (item.customerType && item.customerType === 2) {
        vip = formatMessage(globalMessages.limitedNotVIP, { symbol: ',' });
      } else {
        vip = '';
      }
      const openDay = commonHelper.renderDay(item.weekdays);
      const period = commonHelper.renderTime(item.periodStart, item.periodEnd);
      let condition = '';
      if (vip || openDay || period) {
        condition = `${vip + openDay + period}`;
        const length = condition.length;
        condition = formatMessage(globalMessages.conditionEnable, { condition: condition.substring(0, length - 1) });
      }
      const productName = item.applyProductType === 1 ? <FormattedMessage {...globalMessages.allGoods} /> : <FormattedMessage {...globalMessages.someGoods} />;
      return (
        <p
          className={classnames('shopdiscount-item', {
            jian: item.type && item.type === 1,
            zhe: item.type && item.type === 2,
          })}
          key={index}
        >
          <span className="spanitem">
            {item.isHalfPrice ? '' : item.dishId ? formatDishesData[item.dishId].name : productName}
            {/* {item.dishId ? formatDishesData[item.dishId].name : productName} */}

            {item.dishId ? formatDishesData[item.dishId].spec && `(${formatDishesData[item.dishId].spec})` : false}
            {this.construntRuleName(item)}
            {condition || this.construntDishNum(item, condition)
              ? `（${condition}
              ${this.construntDishNum(item, condition)}）`
              : false}
          </span>
        </p>
      );
    });
    return scrollAll;
  },
  // 更多优惠展示文案：部分商品每满1份限免x份加料
  chargeDiscountPartFunc() {
    const { limitedMarketing } = this.props;
    const type = sessionStorage.getItem('tagsType');
    // 只是堂食下的快餐才展示
    if (!type || type === 'WM') {
      return;
    }
    if (!limitedMarketing || limitedMarketing.length === 0) {
      return;
    }
    // 后端返回数组但只有一项，所有取第0个
    const limitedMarketingItem = limitedMarketing[0];
    const targetArray = limitedMarketingItem.marketRuleDtos ? limitedMarketingItem.marketRuleDtos : [];
    return (
      targetArray &&
      targetArray.length !== 0 &&
      targetArray.map((item, index) => {
        const desc = ` 每满1份限免${item.policyValue1}份加料 `;
        return (
          <p key={index} className="shopdiscount-item mian">
            <span className="spanitem">
              <span>
                <FormattedMessage {...globalMessages.someGoods} />
              </span>
              <span>{desc}</span>
            </span>
          </p>
        );
      })
    );
  },
  animatePartFunc() {
    const { shopInfo } = this.props;
    const { totalShowScroll } = this.state;
    const formatDishesData = shopInfo.formatDishesData;
    const infoList = totalShowScroll || [];
    const animateAll = infoList.map((item, index) => {
      if (item.dishId && !formatDishesData[item.dishId]) {
        return [];
      }
      const productName = item.applyProductType === 1 ? <FormattedMessage {...globalMessages.allGoods} /> : <FormattedMessage {...globalMessages.someGoods} />;
      if (item.type === -1) {
        return (
          <div className="ads-column__content of" key={index}>
            <i className="icon icon-notice"></i>
            <span className="detail o-text-ellipsis o-flex__fluid">
              <span className="detail-inner o-text-ellipsis">
                <FormattedMessage {...shopMessages.announcement} />：{item.notice}
              </span>
            </span>
          </div>
        );
      } else if (item.type === -2) {
        return (
          <div className="ads-column__content of" key={index}>
            <i className="icon icon-notice"></i>
            <span className="detail o-text-ellipsis o-flex__fluid">
              <span className="detail-inner o-text-ellipsis">
                <FormattedMessage {...shopMessages.openhour} />：{item.openShopTimeStr || <FormattedMessage {...globalMessages.allDay} />}
              </span>
            </span>
          </div>
        );
      }
      return (
        <div className="ads-column__content of" key={index}>
          <i
            className={classnames('icon', {
              'icon-jian': item.type && item.type === 1,
              'icon-zhe': item.type && item.type === 2,
            })}
          ></i>
          <span className="detail o-text-ellipsis o-flex__fluid">
            <span className="detail-inner o-text-ellipsis">
              {/* {item.dishId ? formatDishesData[item.dishId].name : productName} */}
              {item.isHalfPrice ? '' : item.dishId ? formatDishesData[item.dishId].name : productName}
              {item.dishId ? formatDishesData[item.dishId].spec && `(${formatDishesData[item.dishId].spec})` : false}
              {this.construntRuleName(item)}
            </span>
          </span>
        </div>
      );
    });
    return animateAll;
  },

  setSearchPage(evt) {
    const { setSearchPage } = this.props;

    evt.preventDefault();
    evt.stopPropagation();
    setSearchPage(evt);
  },

  renderAdsMethod() {
    const { shopInfo, multiMarketing, flodUpAppendCss, isHDL } = this.props;
    // 海底捞定制需求-将此处文案修改为 联系商家
    if (isHDL) {
      return (
        <span>
          联系商家
          <i className="btn-arrow-right"></i>
        </span>
      );
    }

    if (flodUpAppendCss) {
      return (
        <div className="ads-search" onTouchTap={this.setSearchPage}>
          <img src={searchLogo} className="ads-search__img" alt="search" />
        </div>
      );
    }

    if (shopInfo.marketMatchDishes || (multiMarketing && multiMarketing.length) || shopInfo.notice) {
      return (
        <span>
          <FormattedMessage {...shopMessages.morePrivilege} />
          <i className="btn-arrow-right"></i>
        </span>
      );
    }

    return (
      <span>
        <FormattedMessage {...shopMessages.info} />
        <i className="btn-arrow-right"></i>
      </span>
    );
  },
  render() {
    const { animation } = this.state;
    const { flodUpAppendCss } = this.props;
    const animatePart = this.animatePartFunc();
    const adsMethod = this.renderAdsMethod();

    return (
      <div className={`ads-column-container ads-column-container__${flodUpAppendCss}`}>
        <div className="ads-column o-flex" onTouchTap={this.showAllDiscount}>
          <div className="o-flex__fluid of ads-scroll">
            <div className="ads-column__content-outer" style={animation}>
              {animatePart}
            </div>
          </div>
          <div className="o-flex__fixed o-flex ads-more">{adsMethod}</div>
        </div>
      </div>
    );
  },
});
module.exports = AdsColumn;



// WEBPACK FOOTER //
// ./src/component/dish-menu/ads-column.jsx